<template>
  <div class="analysis-report-page col-block">
    <div class="option-container row-block">
      <div class="data-block row-block">
        <template v-if="conditions.filters.product">
          <div><b>品項：</b>{{ getFilterTitle('product') }}</div>
          <div :style="{ width: '50px' }"></div>
        </template>
        <template v-if="conditions.filters.country">
          <div><b>目標市場：</b>{{ getFilterTitle('country') }}</div>
          <div :style="{ width: '50px' }"></div>
        </template>
        <template v-if="dataType === 'country' && conditions.filters.year">
          <div><b>數據年份：</b>{{ getFilterTitle('year') }}</div>
          <div :style="{ width: '50px' }"></div>
        </template>
        <template v-if="dataType === 'year' && country">
          <div><b>{{ { competitiveness: '競爭國家', attraction: '市場國家', toolcompetitiveness: '競爭國家', toolattraction: '市場國家' }[analysisType] }}：</b>{{ getCountryTitle() }}</div>
          <div :style="{ width: '50px' }"></div>
        </template>
      </div>
      <div class="button-block row-block"></div>
    </div>
    <div class="content-container" :style="{ flex: 1 }">
      <div class="report-block row-block stretch">
        <div class="list-container col-block" :style="{ width: '400px' }">
          <div class="table-container col-block" :style="{ height: '50px' }">
            <div class="thead default-shadow">
              <div class="tr row-block">
                <div
                  v-for="(option, index) in tableOptions"
                  :key="index"
                  class="th row-block"
                  :class="option.class"
                  :style="option.width ? { width: option.width } : { flex: 1 }"
                  @click="e => option.sort !== false && tableSortBy(option.value)"
                >
                  <span>{{ option.title }}</span>
                  <div :style="{ width: '5px' }"></div>
                  <i v-if="option.sort !== false" :class="['fa', 'fa-sort' + (sort.order[sort.value.indexOf(option.value)] || '')]" aria-hidden="true"></i>
                  <div :style="{ flex: 1 }"></div>
                </div>
              </div>
            </div>
          </div>
          <div class="table-container col-block sub-shadow" :style="{ flex: 1 }">
            <div class="tbody" :style="{ flex: 1 }">
              <div :style="{ height: 0 }">
                <div class="tr row-block" v-for="(report, cindex) in reports" :key="cindex">
                  <div class="container-block row-block">
                    <div
                      v-for="(option, index) in tableOptions"
                      :key="index"
                      class="td row-block"
                      :class="option.class"
                      :style="option.width ? { width: option.width } : { flex: 1 }"
                    >
                      <span
                        :title="(option.display || (x => x))(report[option.value], cindex)"
                        :style="(option.style || (() => {}))(report[option.value])"
                        @click="e => (option.func || (() => {}))(report)"
                      >{{ (option.display || (x => x))(report[option.value], cindex) || '--' }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="page-container center-block">
            <pageButtons
              v-if="pageData.total"
              :default="pageData.selectedPage"
              :display="pageData.display"
              :total="pageData.total"
              :buttonRange="pageData.buttonRange"
              @selectPage="page => { pageData.selectedPage = page; searchDatas() }"
            ></pageButtons>
          </div>
        </div>
        <div class="report-container" :style="{ flex: 1 }">
          <div v-if="currentReportID" class="report-detail-container">
            <reportDetail
              :reportID="currentReportID"
              :func="{
                getReportTags: this.getReportTags
              }"
              @setFilter="() => {}"
            ></reportDetail>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getProductByCategorys, getReports } from '../../api'
import reportDetail from '../../components/report/detail'
import pageButtons from '../../components/tool/pageButtons'
import routeLoading from '../../mixins/routeLoading'
import { dateFormat } from '../../constants/global/util'
import { mapGetters } from 'vuex'

export default {
  components: {
    reportDetail,
    pageButtons
  },
  mixins: [
    routeLoading
  ],
  props: {
    dataType: {
      type: String,
      required: true
    },
    country: {
      Type: Object,
      default: () => null
    },
    state: {
      type: String,
      required: true
    },
    filterOptions: {
      type: Object,
      required: true
    },
    conditions: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      reports: [],
      currentReportID: null,
      productByCategorys: [],
      onSearch: false,
      pageData: {
        selectedPage: 1,
        display: 12,
        total: null,
        buttonRange: 7
      },
      sort: {
        value: [],
        order: []
      }
    }
  },
  computed: {
    ...mapGetters([
      'countrys'
    ]),
    analysisType () {
      return this.$route.name
    },
    // static
    productOptions () {
      return [
        ...Array.prototype.concat.apply([], Object.entries(this.productByCategorys).map(([category, products]) => Object.entries(products).map(([code, product]) => ({ title: product.chinese_name, value: code, type: product.product_type, category: category })))),
        { title: '其他', value: '其他', type: '其他', category: '其他' }
      ]
    },
    moduleOptions () {
      return [
        { title: '市場吸引力', value: 'market_attractiveness' },
        { title: '市場競爭力', value: 'market_competitiveness' },
        { title: '零售價格分析', value: 'product_prices' },
        { title: '其他', value: 'others' }
      ]
    },
    yearOptions () {
      let year = (new Date()).getFullYear()
      return [
        { title: '無', value: '無' },
        ...(new Array(year - 2000)).fill('').map((_, i) => ({ title: year - i + '', value: year - i + '' }))
      ]
    },
    countryOptions () {
      return this.countrys.map(([key, value]) => ({
        title: value.chinese_name + '(' + value.iso_name + ')',
        value: key,
        country: value
      }))
    },
    tableOptions () {
      return [
        {
          title: '發表時間',
          value: 'publish_time',
          width: '150px',
          display: value => value ? dateFormat(new Date(value), 'yyyy/MM/dd hh:mm') : ''
        },
        {
          title: '報告標題',
          value: 'title',
          style: () => ({
            'color': '#3967A6',
            'text-decoration': 'underline',
            'cursor': 'pointer'
          }),
          func: report => this.selectReport(report)
        }
      ]
    }
  },
  methods: {
    async fetchData () {
      await this.fetchProductByCategorys()
      await this.fetchReports()
    },
    async fetchProductByCategorys () {
      try {
        let config = this.$ls.get('userInfo')
        let response = await getProductByCategorys(config)
        let productByCategorys = response.data
        this.productByCategorys = productByCategorys
      } catch (error) {
        throw error
      }
    },
    async fetchReports (filters) {
      try {
        let config = this.$ls.get('userInfo')
        filters = filters || this.filters || {}
        let data = {
          product_code: this.conditions.filters['product'],
          countries: { competitiveness: this.country.country_code, attraction: this.country.partner_code, toolcompetitiveness: this.country.country_code, toolattraction: this.country.partner_code }[this.analysisType]
        }
        this.pageData.selectedPage && (data.page = this.pageData.selectedPage)
        this.pageData.display && (data.item_per_page = this.pageData.display)
        this.sort.value[0] && (data.order_by = this.sort.value[0])
        this.sort.order[0] && (data.order_method = this.sort.order[0].replace(/^-/, ''))
        let response = await getReports(data, config)
        let reports = response.data.data.elements
        this.pageData.total = response.data.data.items_count
        this.reports = reports
      } catch (error) {
        throw error
      }
    },
    async searchDatas (init) {
      this.onSearch = true
      await this.fetchReports(init)
      this.onSearch = false
    },
    getFilterTitle (value) {
      if (!this.conditions.filters[value]) {
        return ''
      }
      return this.filterOptions.filters.find(filter => filter.value === value).options.find(option => option.value === this.conditions.filters[value]).title
    },
    getCountryTitle () {
      if (!this.country) {
        return ''
      }
      return { competitiveness: this.country.country_name, attraction: this.country.partner_name, toolcompetitiveness: this.country.country_name, toolattraction: this.country.partner_name }[this.analysisType]
    },
    async selectReport (report) {
      this.currentReportID = report.id
    },
    getReportTags (report) {
      let tags = []
      let product = this.productOptions.find(option => option.title === report.product_name || option.value === report.product_code)
      if (product) {
        tags.push({
          title: product.title,
          filter: {
            category: product.category,
            product_code: product.value
          }
        })
      }
      if (report.countries && report.countries.length) {
        tags = [
          ...tags,
          ...report.countries.map(country => this.countryOptions.find(option => option.value === country)).filter(x => x).map(option => ({
            title: option.country.chinese_name,
            filter: {
              countries: option.title
            }
          }))
        ]
      }
      let _module = this.moduleOptions.find(option => option.value === report.module)
      if (_module) {
        tags.push({
          title: _module.title,
          filter: {
            module: _module.value
          }
        })
      }
      let year = this.yearOptions.find(option => option.value + '' === report.year + '')
      if (year) {
        tags.push({
          title: year.title,
          filter: {
            year: year.value
          }
        })
      }
      return tags
    },
    tableSortBy (value) {
      let position = this.sort.value.indexOf(value)
      if (position === 0) {
        let order =
          this.sort.order[position] === '-asc' ? '-desc' : '-asc'
        this.sort.order.splice(position, 1)
        this.sort.order.unshift(order)
      } else {
        let order =
          position !== -1
            ? this.sort.order[position] === '-asc' ? '-desc' : '-asc'
            : undefined
        position = position !== -1 ? position : 0
        this.sort.value.splice(position, 1)
        this.sort.order.splice(position, 1)
        this.sort.value.unshift(value)
        this.sort.order.unshift(order || '-asc')
      }
      this.searchDatas()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/analysis/report.vue